/** The outcome notice of a successful submission: the document is up to date, what appeared or disappeared in it, and the reopening of a verified document. */
const describeSaveOutcome = (
	appearedCount: number,
	disappearedCount: number,
	wasVerified: boolean,
): string => {
	const parts = ['Enregistré : le document est à jour.'];

	if (appearedCount === 1) {
		parts.push('1 passage affiché.');
	} else if (appearedCount > 1) {
		parts.push(`${appearedCount} passages affichés.`);
	}

	if (disappearedCount === 1) {
		parts.push('1 passage masqué.');
	} else if (disappearedCount > 1) {
		parts.push(`${disappearedCount} passages masqués.`);
	}

	if (wasVerified) {
		parts.push('Le document repasse « En cours de vérification ».');
	}

	return parts.join(' ');
};

export default describeSaveOutcome;
